<template>
  <div class="container">
    <content-template>
      <template slot="left">線上常識問答比賽</template>
      <template slot="right">
        <li class="media-navbar">
          <router-link to="/common-sense">線上常識問答比賽</router-link>
        </li>
        <li class="media-navbar">
          <router-link to="/name-list">賽事名單公佈</router-link>
        </li>
        <li class="media-navbar media-navbar-none-margin nav-float-left">
          <a class="is-check">過往題目</a>
        </li>
      </template>
      <template slot="banner">
        <img src="./banner.jpg" class="top-banner" alt="">
      </template>
      <template slot="content">
        <div class="col-xs-12 none-padding" style="margin-top: 50px;">
          <div v-for="(file) in files" :key="file.id" class="col-xs-12 none-padding col-sm-6 col-md-4 ">
            <a :href="file.file_url" class="quesiton-a" target="_blank">
              <div class="one-question ">
                <img src="@/assets/image/download.png" alt="">
                <div class="title-time">
                  <h5>{{file.name}}</h5>
                  <span>日期：{{file.create_time*1000|datefmt("YYYY/MM/DD")}}</span>
                </div>
              </div>
            </a>
          </div>
          <!--<div class="col-xs-12 none-padding col-sm-6 col-md-4 ">-->
            <!--<div class="one-question ">-->
              <!--<img src="@/assets/image/download.png" alt="">-->
              <!--<div class="title-time">-->
                <!--<h5>線上常識問答比賽第一期題目期題目期題目</h5>-->
                <!--<span>日期：2018/10/10</span>-->
              <!--</div>-->
            <!--</div>-->
          <!--</div>-->

        </div>
      </template>
    </content-template>
  </div>

</template>
<script>
import contentTemplate from '../contentTemplate'
export default {
  components: {
    'content-template': contentTemplate
  },
  data () {
    return {
      files: [],
      registerTime: ''
    }
  },
  methods: {
    getFiles: function () {
      var that = this
      this.$axios.get('/competition/file')
        .then(function (response) {
          that.files = response.data.data
          // console.log(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  created () {
    this.getFiles()
  }
}
</script>
<style scoped>
  .container {
    padding: 0px;
  }
  .one-question {
    border:2px solid rgba(0,0,0,0);
    width: 360px;
    height: 100px;
    cursor: pointer;
  }

  .one-question:hover{
    border-radius:13px;
    border:2px solid rgba(97,123,228,1);
  }
  .one-question:hover .title-time h5,.one-question:hover .title-time span{
    color: #526add;
  }
  .one-question img{
    height: 60px;
    width: 70px;
    margin-top: 20px;
    margin-left: 15px;
  }
  .quesiton-a:hover{
    text-decoration: none;
  }
  .one-question .title-time{
    width: 265px;
    display: inline-block;
    vertical-align:middle;
  }

  .one-question .title-time h5{
    font-size:18px;
    color:rgba(86,86,86,1);
  }
  .one-question .title-time span{
    font-size:14px;
    color:rgba(86,86,86,1);
  }
  @media (min-width: 992px) and (max-width: 1200px) {
    .one-question {
      width: 300px;
    }
    .one-question img{
      height: 60px;
      width: 70px;
      margin-left: 5px;
    }
    .one-question .title-time{
      width: 210px;
    }
  }

  @media (max-width: 767px) {
    .one-question {
      width: 330px;
    }
    .one-question img{
      margin-left: 5px;
    }
    .one-question .title-time{
      width: 240px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/commonSense/allQuestion.vue